import { useCallback, useEffect, useState } from 'react';

/*
 * Which navigation a person uses (Rudy 2026-11-03): 'sidebar' (ChatGPT style, design "Option A", Phil's ask) or
 * 'top' (the top bar, design "Option B"). Both reach every page; each person switches in the account menu, kept in
 * this browser. A deployment picks the default with VITE_DEFAULT_NAV_STYLE.
 */
export const NAV_STYLES = ['sidebar', 'top'];
const STORAGE_KEY = 'bluebear.nav-style';
const EVENT = 'bluebear:nav-style';

export function defaultNavStyle() {
  const configured = import.meta.env?.VITE_DEFAULT_NAV_STYLE;
  return NAV_STYLES.includes(configured) ? configured : 'sidebar';
}

export function readNavStyle() {
  try {
    const stored = globalThis.localStorage?.getItem(STORAGE_KEY);
    if (NAV_STYLES.includes(stored)) return stored;
  } catch {
    /* storage blocked: the default applies */
  }
  return defaultNavStyle();
}

export function useNavStyle() {
  const [style, setStyle] = useState(readNavStyle);
  useEffect(() => {
    const sync = () => setStyle(readNavStyle());
    window.addEventListener(EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);
  const change = useCallback((next) => {
    if (!NAV_STYLES.includes(next)) return;
    try {
      globalThis.localStorage?.setItem(STORAGE_KEY, next);
    } catch {
      /* not kept across reloads; still switches now */
    }
    setStyle(next);
    window.dispatchEvent(new Event(EVENT));
  }, []);
  return [style, change];
}
